import angular from 'angular'
import timePickerService from './timePicker.service'
import plannedPublishTimePickers from './plannedPublish.timePickers.component'
import schedulePublishTimePickers from './schedulePublish.timePickers.component'

export default angular
  .module('ellipsis.timePicker', [])
  .service('timePickerService', timePickerService)
  .component('plannedPublishTimePickers', plannedPublishTimePickers)
  .component('schedulePublishTimePickers', schedulePublishTimePickers)
